/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "@nf/constants";
import {
  IPauseSubscriptionRequestModel,
  IPauseSubscriptionResponseModel,
  IUnpauseSubscriptionRequestModel,
} from "../models";
import { AxiosSubscriber } from "./AxiosSubscriber";

export class PauseSubscriptionService {
  get url(): string {
    return "/v1";
  }

  public pauseSubscription = (
    data: IPauseSubscriptionRequestModel
  ): Observable<IPauseSubscriptionResponseModel> =>
    new Observable(
      (observer: Observer<IPauseSubscriptionResponseModel>) =>
        new AxiosSubscriber(observer, {
          data: {
            duration_count: data.pausePeriod,
            duration_unit: "month",
          },
          method: HTTP_METHOD.PATCH,
          url: `${this.url}/subscriptions/${data.id}/pause`,
        })
    );

  public unpauseSubscription = (
    data: IUnpauseSubscriptionRequestModel
  ): Observable<IPauseSubscriptionResponseModel> =>
    new Observable(
      (observer: Observer<IPauseSubscriptionResponseModel>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.PATCH,
          url: `${this.url}/subscriptions/${data.id}/unpause`,
        })
    );
}
